import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountCampaignEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCampaignEditContainer";
    }
    render(){
        let tables=this.zidx.peakidxShadowRoot.querySelectorAll(".zidxAccountCampaignEditContainer .zidxRecordSort");
        for(let i=0;i<tables.length;i++){
            this.zidx.setupRecordSort(tables[i], function(result:any){});
        }
    }
}
